import { zalo_chat } from 'Components/ProductDetail/product.module.scss';
import { ZaloIcon } from '../SVG/MoreSVG';
import classNames from 'classnames';
import Link from 'next/link';

export default function ZaloChat(props) {
  const { buttonIcon, className, text = 'Liên hệ' } = props;

  return (
    <>
      <a
        href="https://zalo.me/0898318328"
        target="_blank"
        rel="noreferrer"
        className={classNames(zalo_chat, className)}>
        <ZaloIcon className="ml-4 h-4 w-2" />
        <span className="pl-2">{text}</span>
      </a>
    </>
  );
}
